export default {"src":"/_next/static/image/src/images/our-food/blueberries.2d0aad7d9acacd45f0b48f0926ea24e2.svg","height":30,"width":60};